import { useEffect } from 'react';
import {
  clearCbullshitcodingFadeTimeout,
  type CbullshitcodingContentStateControls,
} from './CbullshitcodingContentState';

interface UseCbullshitcodingPendingStringsFadeInput
  extends CbullshitcodingContentStateControls {
  isFadingOut: boolean;
  pendingStrings: string[] | null;
}

export function useCbullshitcodingPendingStringsFade({
  fadeDurationMs,
  fadeTimeoutRef,
  isFadingOut,
  pendingStrings,
  resetTypingState,
  setIsFadingOut,
  setLoadedStrings,
  setPendingStrings,
}: UseCbullshitcodingPendingStringsFadeInput): void {
  useEffect(() => {
    if (!isFadingOut || pendingStrings == null) {
      return undefined;
    }

    fadeTimeoutRef.current = setTimeout(() => {
      resetTypingState();
      setLoadedStrings(pendingStrings);
      setPendingStrings(null);
      setIsFadingOut(false);
    }, fadeDurationMs);

    return () => {
      clearCbullshitcodingFadeTimeout({ timeoutRef: fadeTimeoutRef });
    };
  }, [
    fadeDurationMs,
    fadeTimeoutRef,
    isFadingOut,
    pendingStrings,
    resetTypingState,
    setIsFadingOut,
    setLoadedStrings,
    setPendingStrings,
  ]);
}
